import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../Auth/FirebaseAuth'; // Import the logout function
import { useUserProfile } from '../Profile/UserProfileContext'; // Import the user profile context

const UserDisplay = () => {
   const location = useLocation();
   const isHomePage = location.pathname === '/';
   const navigate = useNavigate(); // For redirecting after logout
   
   // Get user profile from context
   const { userProfile } = useUserProfile();
  
   // Use actual user profile data instead of placeholders
   const displayName = userProfile.userName || "Username";
   const displayHandle = userProfile.userHandle || "";

   // Handle logout button click
   const handleLogout = async () => {
     try {
       await logout(); // Call the Firebase logout function
       navigate('/login'); // Redirect to login page after logout
     } catch (error) {
       console.error("Failed to log out:", error);
     }
   };

   if (!isHomePage) {
     return null;
   }

   return (
     <Box className='sidebar-items' sx={{ display: 'flex', flexDirection: 'column', gap: 1, flexGrow: 1, }}>
       <Box
         sx={{
           display: 'flex',
           flexDirection: 'column',
           width: '280px',
           maxWidth: '100%',
           height: '7rem',
           mt: 3,
           borderRadius: '.5rem',
           justifyContent: 'center',
         }}
       >
         <Box
           className="user-profile"
           sx={{
             display: 'flex',
             justifyContent: 'left',
             alignItems: 'center',
             ml: 0,
             gap: 1,
             overflow: 'hidden'
           }}
         >
           <AccountCircleIcon 
             sx={{
               fontSize: '6rem',
               color: '#000',
             }}
           />
           <Box className="user-name-items" sx={{ display: 'flex', flexDirection: 'column' }}>
             <Typography 
              className="user-username" 
              sx={{ 
                fontSize: '1rem', 
                fontWeight: 500,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'wrap',
                maxWidth: '110px' 
              }}
            >
              {displayName}
            </Typography>
             <Typography className="user-name" sx={{ fontSize: '0.8rem', color: '#666' }}>
               {displayHandle}
             </Typography>
           </Box>
           <Button
             variant='text'
             onClick={handleLogout}
             sx={{
               color: '#4f46e5',
               fontSize: '1rem',
               fontWeight: 500,
               textTransform: 'none',
               //ml: 1
             }}
           >
             Logout
           </Button>
         </Box>
       </Box>
     </Box>
   );
};

export default UserDisplay;